export default "__VITE_ASSET__C4nHXSKS__"